import useGDPRStatus from './useGDPRStatus'

export default useGDPRStatus
